import { Alert, Button, Card as AntdCard, Checkbox, Form, message, Popconfirm, Select, Space, Row, Col, Input, Modal, Tooltip } from 'antd'
import _ from 'lodash'
import React from 'react'
import { api, app, use } from 'xadmin'
import { HasPermission } from 'xadmin-auth'
import { C, Icon } from 'xadmin-ui'

const UidComponent = props => {
  const { input: { value, onChange }, type } = props
  const [isModalVisible, setIsModalVisible] = React.useState({ visible: false, loading: false })
  const [disabled, setDisabled] = React.useState(true)
  const { model, department, id, values } = use('form', state => ({
    model: state.values && state.values.model,
    department: state.values && state.values.department,
    id: state?.values?.id,
    values: state?.values
  }))

  React.useEffect(() => {
    if (type == 'node') {
      if ((/^[\u2E80-\u9FFF\w\-\_\!\@\$\#\:]{1,}$/ig.test(value))) { setDisabled(false) } else { setDisabled(true) }
    } else {
      if (value) { setDisabled(false) } else { setDisabled(true) }
    }
  }, [value])

  const handleOk = () => {
    setIsModalVisible(prev => ({ ...prev, loading: true }))
    delete values.uid
    let changeObj = type == 'node' ? { ...values, id: value } : { ...values, fullName: `${values.name}(${value})`, id: value }
    api({ name: `core/${type}/change` })
      .fetch(`/${_.includes(id, '#') ? encodeURIComponent(id) : id}`, {
        method: 'PATCH',
        body: JSON.stringify(changeObj)
      })
      .then(({ json }) => {
        message.success('修改成功')
        if (type == 'node') {
          app.go(`app/nodes?model=${model.id}`)
          app.go(`app/model/node/${value}/edit`)
        } else if (type == 'department') {
          app.go('app/model/Department/list')
          app.go(`app/model/department/${value}/edit`)
        }
        setIsModalVisible({ loading: false, visible: false })
      })
      .catch((err) => {
        setIsModalVisible({ loading: false, visible: false })
        onChange(id)
        Object.values(JSON.parse(err.message)).map(item => { message.error(item, item?.detail) })
      })
  }

  return (
    <Space>
      {
        id ?
          (
            <>
              <div style={{ padding: '0 20px 0 10px' }}>{value}</div>
              <Button onClick={() => setIsModalVisible(prev => ({ ...prev, visible: true }))}><Icon type="edit"></Icon></Button>
              <Modal destroyOnClose={true} title={`修改${values.name}编号`} visible={isModalVisible.visible} onCancel={() => {
                setIsModalVisible({ visible: false, loading: false }); onChange(id)
              }}
                footer={
                  <>
                    <Button onClick={() => { setIsModalVisible({ visible: false, loading: false }); onChange(id) }}>取消</Button>
                    <Tooltip title={`确定后${values.name}编号即修改成功，同时将会删除原有资产创建新资产`}>
                      <Button loading={isModalVisible.loading} type="primary" disabled={disabled} onClick={handleOk}>确定</Button>
                    </Tooltip>
                  </>
                }>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <div style={{ color: 'red', marginRight: '.5rem' }}>*</div>
                  <Input {...props.input} onChange={e => {
                    onChange(e.target.value)
                  }} />
                </div>
                <div style={{ fontSize: '12px', color: 'red' }}>{type == 'node' ? '修改编号将会删除原有资产创建新资产' : null}</div>
              </Modal>
            </>
          ) :
          <Input {...props.input} value={value} onChange={(e) => { onChange(e.target.value) }} />
      }
    </Space>
  )
}

export default UidComponent